import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  FieldConfig,
  FieldDataTypes,
  HasUidInterface,
  NameableInterface,
  nNumber,
  nString,
  uNumber,
  Uuid,
} from '@hidat/huijs-common';
import { ResourceConfig, SearchFilterConfig } from '@hidat/huijs-resource';
import {
  splixerFieldConfigs,
  splixerSystemFields,
} from './splixer-fields.const';
import { LicensingKlasses, ProgramKlasses } from './splixer-types';
import {
  BrandedResource,
  ExtendedBrandingFields,
  ExtendedBrandingInterface,
} from './branded-resource.interface';
import { HashViews } from './hash-views';

export const ProgramConfig: ResourceConfig = new ResourceConfig('Program')
  .addFields(
    [
      splixerFieldConfigs.intId,
      splixerFieldConfigs.uid,
      splixerFieldConfigs.status,

      splixerFieldConfigs.name.setRequired(true),
      splixerFieldConfigs.tagLine,
      splixerFieldConfigs.description,
      splixerFieldConfigs.imageUrl,
      new FieldConfig('validSegments', FieldDataTypes.INTEGER).setEditable(
        false,
      ),
      new FieldConfig('duration', FieldDataTypes.INTEGER).setEditable(false),
      new FieldConfig('licensingKlass'),
      new FieldConfig('shortCode'),
      new FieldConfig('remoteCode'),
      new FieldConfig('branding', FieldDataTypes.HASH),
      new FieldConfig('priority', FieldDataTypes.INTEGER),
      new FieldConfig('urlStub'),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    splixerFieldConfigs.channelId,
    splixerFieldConfigs.hostId,
    splixerFieldConfigs.stationId,
    splixerFieldConfigs.remoteId.setEditable(false),
    splixerFieldConfigs.remoteCode.setEditable(false),
    new FieldConfig('klass'),
    new FieldConfig('minSegmentLength', FieldDataTypes.INTEGER),
    new FieldConfig('maxSegmentLength', FieldDataTypes.INTEGER),
    new FieldConfig('rssFeedMode', FieldDataTypes.INTEGER),
    new FieldConfig('syncLevel', FieldDataTypes.INTEGER),
    ...splixerSystemFields,
  ])
  .setSorts({
    name: 'name',
    createdat: 'createdAt',
    status: {
      dbName: 'status',
      secondarySort: {
        dbName: 'name',
      },
    },
    klass: {
      dbName: 'klass',
      secondarySort: {
        dbName: 'name',
      },
    },
    priority: {
      dbName: 'priority',
      secondarySort: { dbName: 'name' },
    },
  })
  .setDefaultSort('name');

export const ProgramIncludes = {
  host: 'host',
  station: 'station',
  channel: 'channel',
};

export const PlayerProgramIncludes = {
  mix_count: 'mix_count',
  show_count: 'show_count',
  last_show_mix: 'last_show_mix',
  default_mix: 'default_mix',
  shows: 'shows',
  mixes: 'mixes',
};

export const ProgramBrandingFields = [
  ...ExtendedBrandingFields,
  new FieldConfig('broadcastTimes'),
  new FieldConfig('keyword'),
];
export const ProgramFilterConfig = new SearchFilterConfig(ProgramConfig, {
  only: ['name', 'klass', 'status'],
});

export interface ProgramBrandingInterface extends ExtendedBrandingInterface {
  broadcastTimes?: nString;
  keyword?: nString;
}

export enum RssFeedMode {
  None = 0,
  Segment = 1,
  Show = 2,
}

export interface PlayerProgramInterface
  extends
    SplixerResourceInterface<number>,
    NameableInterface,
    BrandedResource<number>,
    HasUidInterface {
  tagLine: nString;
  description: nString;
  imageUrl: nString;
  validSegments: number | undefined;
  duration: number | undefined;
  licensingKlass: LicensingKlasses | undefined;
  shortCode: nString;
  branding: ProgramBrandingInterface | undefined;
  priority: uNumber;
  urlStub: nString;
  defaultMixId: number | undefined;
  klass: ProgramKlasses | undefined | null;
}

export interface ProgramInterface extends PlayerProgramInterface {
  remoteCode: nString;
  remoteId: nNumber;

  uid: Uuid | undefined;
  tenantId: Uuid | undefined;
  stationId: number | undefined;
  channelId: number | undefined; //optional
  hostId: number | undefined;
  minSegmentLength: nNumber;
  maxSegmentLength: nNumber;
  rawProgramId: uNumber;
  rssFeedMode: RssFeedMode | undefined;
  syncLevel: uNumber;

  /* Show ingestion parameters, currently not used anymore
  allowCrossShowSegments: boolean;
  allowMultiSegments: boolean;
  autoGenerateSegments: boolean;
  crossShowMaxOverlap: number;
  includeEndBreaks: boolean;
  includeMidBreaksInPlaylist: boolean;
  includeStartBreaks: boolean;
  maxMicBreakLength: number;
  maxMultiSegMicLength: number;
  minMicBreakLength: number;
  useComboMediaItems: boolean;
  targetSegmentLength: number;
  */
}

export interface ProgramFilter {
  minPriority?: number;
  klass?: string;
  licensingKlass?: LicensingKlasses;
}
